const PropTypes = require('prop-types');
// @ vendors
const React = require('react');

// @ utilities
const { formatText } = require('core/i18n').i18n;

// @ components
const MortgageRequestHolderEconomicAnotherLoan = require('./mortgageRequestHolderEconomicAnotherLoan/mortgageRequestHolderEconomicAnotherLoan');

// @ constants
const { DOCUMENTS_STATUS, OTHER_LOANS_TYPES, OTHER_LOANS_FILE_TYPES } = require('constants/mortgageRequestHolderData');

class MortgageRequestHolderEconomicOtherLoans extends React.Component {
    componentWillMount() {
        const { requestSummaryDocumentation, shouldRequestDocumentation } = this.props;

        if (shouldRequestDocumentation) {
            requestSummaryDocumentation();
        }
    }

    getDocumentStatus(immAnotherLoan) {
        const { immSummaryDocs } = this.props;
        const immDocument = immSummaryDocs.get('data').find(immDocument => immDocument.get('idPrestamo') === immAnotherLoan.get('id') &&
            immDocument.get('tipoDocumento') === immAnotherLoan.get('documentType') &&
            immDocument.get('numeroDocumento') === immAnotherLoan.get('documentNumber') &&
            immDocument.get('tipoDocumentoId') === OTHER_LOANS_FILE_TYPES[immAnotherLoan.get('type')]
        );

        let documentStatus = DOCUMENTS_STATUS.NONE;

        if (!!immDocument) {
            documentStatus = immDocument.get('estado');
        }

        return documentStatus;
    }


    buildOtherLoansList() {
        const { deleteOtherLoan, holderEconomic, onEditAnotherLoan, onDownload, immFlagBasedFeatures } = this.props;
        let counter = 0;
        let mortgagesCounter = 0;
        let personalCounter = 0;
        let index, documentLink;

        return this.props.immOtherLoans.reduce((loans, immAnotherLoan) => {
            const documentStatus = this.getDocumentStatus(immAnotherLoan);
            const documentType = OTHER_LOANS_FILE_TYPES[immAnotherLoan.get('type')];
            const loanId = immAnotherLoan.get('id');
            if (immAnotherLoan.get('type') === OTHER_LOANS_TYPES.MORTGAGE) {
                mortgagesCounter++;
                counter = mortgagesCounter;
                index = 0;
                documentLink = formatText('mortgageRequestHolderEconomic-otherLoansMortgageFileLink', [counter]);
            } else {
                personalCounter++;
                counter = personalCounter;
                index = 1;
                documentLink = formatText('mortgageRequestHolderEconomic-otherLoansPersonalFileLink', [counter]);
            }
            loans[index].push(
                <MortgageRequestHolderEconomicAnotherLoan
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immAnotherLoan={immAnotherLoan}
                    key={loanId}
                    counter={counter}
                    documentStatus={documentStatus}
                    documentLink={documentLink}
                    handleDownload={() => onDownload(documentType, loanId)}
                    deleteOtherLoan={deleteOtherLoan}
                    holderEconomic={holderEconomic}
                    onEditAnotherLoan={onEditAnotherLoan}
                />
            );
            return loans;
        }, [[], []]);
    }

    render() {
        const otherLoansList = this.buildOtherLoansList();

        return (
            <div>
                {otherLoansList}
            </div>
        );
    }

}

MortgageRequestHolderEconomicOtherLoans.propTypes = {
    immFlagBasedFeatures: PropTypes.object,
    immOtherLoans: PropTypes.object.isRequired,
    immSummaryDocs: PropTypes.object.isRequired,
    requestDocuments: PropTypes.func.isRequired,
    deleteOtherLoan: PropTypes.func.isRequired,
    holderEconomic: PropTypes.object.isRequired,
    onEditAnotherLoan: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired,
    requestSummaryDocumentation: PropTypes.func.isRequired,
    shouldRequestDocumentation: PropTypes.bool
}

module.exports = MortgageRequestHolderEconomicOtherLoans;
